
 import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';

// project imports
import { SET_MENU } from '../../store/actions';
import { drawerWidth } from '../../store/constant';
import Customization from '../../Layout/Customization';
import Header from './Header';
import Sidebar from './Sidebar';

// assets

import { Outlet, Route, useLocation } from 'react-router-dom';
import RtlProvider from '../../Components/RtlProvider';
import UserApi from '../../api/UserApi';
import { ContextNotification, severitys } from '../../App';
import { createContext, useContext, useEffect, useState } from 'react';
import PrivateRoutList from '../../Router/PrivateRoutList';
import customtheme from "../../themes";
import helper from '../../helper';


export const ContextUserInfo = createContext();
// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    ...theme.typography.mainContent,
    ...(!open && {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            marginRight: -(drawerWidth - 20),
            width: `calc(100% - ${drawerWidth}px)`
        },
        [theme.breakpoints.down('md')]: {
            marginRight: '20px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px',
            marginRight: '10px'
        }
    }),
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginRight: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        width: `calc(100% - ${drawerWidth}px)`,
        [theme.breakpoints.down('md')]: {
            marginRight: '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginRight: '10px'
        }
    })
}));

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    // Handle left drawer
    const leftDrawerOpened = useSelector((state) => state.customization.opened);
    const dispatch = useDispatch();
    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
    };
    const customization = useSelector((state) => state.customization);
    const appid=5;
    const [hasAccess, setHasAccess] = useState(false)
    const [menues, setMenues] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const location = useLocation();
    const [userInfo, setUserInfo] = useState(null);
    const [userRoles, setUserRoles] = useState([]);
    const [userPermissions, setUserPermissions] = useState(null);


    const { setOpen } = useContext(ContextNotification);
    useEffect(() => {
        GetMenues();
        GetPermissions();
        setHasAccess(CheckAccess());
    
    
      }, [location]);
    
      useEffect(() => {
    
        setHasAccess(CheckAccess());
    
      }, [refresh]);
    
    
    
      const GetMenues = () => {
    
        return UserApi.GetMenuItems(appid)
          .then((data) => {
            setMenues(data.data);
    
          })
          .catch(err => {
    
            if (err.response && err.response.data) {
              setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
              setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
              setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            exitToApp();
          }
          );
    
    
      };
    
      const GetPermissions = () => {   
        return (   
          UserApi.GetPermissions(appid)
            .then(async (data) => {
              setUserInfo(data.data.user)
              setUserPermissions(data.data.permisions);
              setUserRoles(data.data.roles)
              setRefresh(old => !old);
            })
            .catch(err => {
              if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
              }
              else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
              }
              else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
              }
            }
            )
        );
      };
      const exitToApp = () => {
        localStorage.clear();      
        window.location.pathname = "/login";
      }

function CheckAccess() {
    var res = false;
    var prout = null;
    var currentPath = location.pathname.trim().trimEnd('/').toLowerCase();
    var pathparts = currentPath.split('/');
    if ((pathparts.length >= 2) && (pathparts[1] === 'dashboard')) {
      if (pathparts.length === 2)
        return true;
      else if ((pathparts.length === 3) && (pathparts[2].toLowerCase() === 'home'))
        res = (userPermissions ? true : false)
      else {
        prout = PrivateRoutList?.find(e => (e.name.toLowerCase() === (pathparts[2] + ':' + pathparts[3])));
        if (prout)
          res = userPermissions?.some(p => (p.claimType.toLowerCase() === pathparts[2]) && (p.claimValue.toLowerCase() === pathparts[3]))
        else {
          prout = PrivateRoutList?.find(e => (e.path.indexOf('/:')===-1?e.path.toLowerCase():e.path.toLowerCase().substring(0, e.path.indexOf('/:'))) === (pathparts.length === 3 ? pathparts[2] : pathparts[2] + '/' + pathparts[3]))
          if (prout) {
            var matchedMenu = menues?.filter(pmenu =>
              prout.name === pmenu.menuName)
            if (matchedMenu?.length===0)
              menues?.map(mnu => {
           var submnu=mnu.children?.filter(pmenu =>
                  prout.name === pmenu.menuName);
                  if(submnu?.length>0)
                matchedMenu = [...matchedMenu,...submnu];
              })
            if (matchedMenu?.length===0)
              menues?.map(mnu => {
                mnu.children?.map(pmenu => {
                  var subsubmnu=pmenu.children?.filter(pmenu => prout.name === pmenu.menuName);
                  if(subsubmnu?.length>0)
                  matchedMenu =[...matchedMenu,...subsubmnu]
                })
              });
            if (matchedMenu?.length>0) {
              res = matchedMenu.some((mnu)=>'/dashboard/'+helper.GetPath(prout.name,mnu.params).toLowerCase() === currentPath);
            }

          }
        }
      }
    }
    return res
  };
    return (
   
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            {/* header */}
            <ContextUserInfo.Provider value={{ userInfo, userPermissions, userRoles,menues }}>
            <AppBar
            
                enableColorOnDark
                position="fixed"
                color="inherit"
                elevation={0}
                sx={{

                    bgcolor: '#F1F1E8',//theme.palette.background.default,
                    transition: leftDrawerOpened ? theme.transitions.create('width') : 'none'
                }}
            >
                
                <Toolbar>
                    <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
                </Toolbar>
            </AppBar>

            {/* drawer */}
            
            {/* main content */}
            <Main theme={customtheme(customization)} open={leftDrawerOpened}>

                <Outlet />
            </Main>
            {/* <Sidebar  drawerOpen={!matchDownMd ? leftDrawerOpened : !leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} /> */}
            <Sidebar  drawerOpen={ leftDrawerOpened } drawerToggle={handleLeftDrawerToggle} />

            <Customization />
            </ContextUserInfo.Provider>
        </Box>
       
    );
};

export default  MainLayout;
